module.exports = __webpack_public_path__ + "img/confidentialities.7424949d.svg";